var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice, } from '@reduxjs/toolkit';
import { pascalCase } from 'change-case';
import { deepMerge } from 'hx-util';
export var createSimpleStore = function (name, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.initialState, initialState = _d === void 0 ? {} : _d, _e = _c.reducers, reducers = _e === void 0 ? {} : _e;
    var slice = createSlice({
        name: name,
        initialState: initialState,
        reducers: __assign(__assign({}, reducers), { update: function (state, action) {
                return deepMerge(state, action.payload);
            }, set: function (state, action) {
                return action.payload;
            } }),
    });
    var res = (_b = {},
        _b["".concat(name, "Reducer")] = slice.reducer,
        _b["set".concat(pascalCase(name))] = slice.actions.set,
        _b["update".concat(pascalCase(name))] = slice.actions.update,
        _b);
    return res;
};
